import { Box } from "@mui/material";
import styled from "styled-components";
import { grey } from "@mui/material/colors";

export const CardsWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	.card {
		background: white;
		border: 1px solid ${grey[300]};
		margin-bottom: 5px;
		padding: 5px;
		position: relative;
		cursor: pointer;
		.card-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
	}
`;
